import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import { PlanStatus, PlanStatusDTO } from 'src/app/cxone/dashboard/modules/plans-status/plans-status.models';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class PlansStatusService {

    constructor(
        private cvApiService: CVApiService
    ) { }

    async loadData(moduleKey: string, isAutoRefresh: boolean, isFirstLoad: boolean): Promise<PlanStatus[]> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        }
        catch (error) {
            console.error("Failed getting module render endpoint for plans status.");
            throw error;
        }
        try {
            const url = `/api/v2/dashboards/modules/planStatusData/${moduleKey}?isAutoRefresh=${!!isAutoRefresh}&isFirstLoad${!!isFirstLoad}`;
            const response = await this.cvApiService.get<PlanStatusDTO[]>(url, renderEndpoint);
            if (response.status_code !== 200)
                throw response;
            else
                return response.data.map(e => new PlanStatus(e));
        }
        catch (error) {
            console.error("Failed getting plans status data.");
            throw error;
        }
    }

    async exportData(moduleKey: string, format: string, isCXOne: boolean): Promise<ApiResponse<string>> {
        let renderEndpoint;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        }
        catch (error) {
            console.error("Failed getting render endpoint.");
            throw error;
        }

        try {
            const response = await this.cvApiService.get<string>(`/api/v2/dashboards/modules/planStatusData/${moduleKey}/export?format=${format}&isCXOne=${isCXOne}`,
                renderEndpoint);
            if (response.status_code !== 200)
                throw response;
            return response;
        } catch (error) {
            console.error("Failed getting plan status data for export.");
        }
    }
}
